package ru.playa.sce.dto

enum class DeleteStatus {

    DELETED,
    ACTIVE,
    ALL
}